import { Hole } from "components/Scorecard/Hole";

export function holeAndRes(user, index, skins, showAsterik, highlightWinScore) {
  const addAsterisk =
    showAsterik && user.holes?.[index].score !== user.holes?.[index].netScore;
  const grossHolePar = user.holes[index].score ?? "-";

  const skinsHoleBool = skins && user.holes[index].win > 0;

  const res = Hole(
    grossHolePar,
    user.holes[index].holePar,
    addAsterisk,
    skinsHoleBool,
    highlightWinScore,
  );

  const quotaRes = (
    <div style={{ color: skinsHoleBool && "white" }}>
      {user?.holes[index]?.quota ?? "-"}
    </div>
  );
  return { skinsHoleBool, quotaRes, res };
}
